import { createFileRoute, Outlet, Link, useLocation } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

const DOCS_MENU = [
  { to: '/docs', labelKey: 'overview' },
  { to: '/docs/quickstart', labelKey: 'quickstart' },
  { to: '/docs/email-inbound', labelKey: 'emailInbound' },
  { to: '/docs/workflows', labelKey: 'workflows' },
  { to: '/docs/templates', labelKey: 'templates' },
  { to: '/docs/storage', labelKey: 'storage' },
  { to: '/docs/api', labelKey: 'api' },
]

export const Route = createFileRoute('/_static/docs')({
  component: DocsLayout,
})

function DocsLayout() {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <main className="container mx-auto py-8 max-w-7xl">
      {/* Header */}
      <div className="mb-12 text-center">
        <h1 className="text-5xl font-bold mb-4">
          {t('docsPage.title')}
        </h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          {t('docsPage.subtitle')}
        </p>
      </div>

      {/* Navigation */}
      <nav className="flex flex-wrap gap-2 mb-8 justify-center">
        {DOCS_MENU.map((item) => {
          const isActive = location.pathname === item.to
          return (
            <Link
              key={item.to}
              {...({ to: item.to } as any)}
              className={`px-3 py-1 rounded font-medium text-sm transition-colors ${
                isActive 
                  ? 'bg-primary text-primary-foreground' 
                  : 'bg-muted text-foreground hover:bg-muted/70'
              }`}
            >
              {t(`docsPage.menu.${item.labelKey}`)}
            </Link>
          )
        })}
      </nav>
      <Outlet />
    </main>
  )
}
